import { useEffect } from "react";

const SITE = "https://hormones.allinprecisionwellness.com";
const INDEXABLE = "index, follow, max-image-preview:large, max-snippet:-1";
const onEmergentHost = () => /\.emergent\.host$/.test(window.location.hostname);

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex || onEmergentHost() ? "noindex, nofollow" : INDEXABLE);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${SITE}${path}`);
  }, [title, description, path, noindex]);
  return null;
};
